export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8473.24a99853.jpg";